export default __webpack_public_path__ + "static/media/right.4eeb2221.svg";